import AssetList from "../components/asset/AssetCrud";

const AssetCrudPage = () => {
  return (
    <>
      <AssetList />
    </>
  );
};

export default AssetCrudPage;
